module.exports = __webpack_public_path__ + "img/iphone-transparent.92a497b2.png";